import { render } from "./CommissionPage.vue?vue&type=template&id=c5b8606e"
import script from "./Commission.js?vue&type=script&lang=js&external"
export * from "./Commission.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__